// extracted by mini-css-extract-plugin
export default {"link":"b81GBR","root":"Grj6jZ","label":"G9Stzs"};